type Mail = {
	subject?: string;
};

type VK = {
	title?: string;
	description?: string;
};

type Telegram = {
	text?: string;
};

type TOptions = Mail | VK | Telegram;

const SHARE_URL = {
	mail: 'mailto:?body={SITE_URL}',
	vk: 'https://vk.com/share.php?url={SITE_URL}&title=123&description=qwe',
	telegram: 'https://t.me/share/url?url={SITE_URL}&text=123',
} as const;

const getQueryParams = (options: TOptions) => {
	return '&' + Object.entries(options)
		.map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
		.join('&');
};

export const getShareUrl = (key: keyof typeof SHARE_URL, url: string, options: TOptions = {}) => {
	return `${SHARE_URL[key].replace('{SITE_URL}', url)}${getQueryParams(options)}`;
};
